import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import useToggle from '../../../../hooks/use-toggle';
import ParadigmModal from '../../../../material/modal';
import AddKeyForm from './add-keys-form';
import { IconButton, Tooltip } from '@material-ui/core';
import { Add } from '@material-ui/icons';

export const AddKeyIcon = (props) => (
  <Tooltip title="Add new API credentials" enterDelay={300}>
    <IconButton color="primary" {...props}>
      <Add fontSize="small" />
    </IconButton>
  </Tooltip>
);

const AddKey = ({ children, source }) => {
  const [open, toggle] = useToggle(false);
  const { addApiKey } = source;

  const addKeySchema = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .max(64, 'Ensure this field has no more than 64 characters.'),
    access_key: Yup.string()
      .required('API Key is required')
      .max(256, 'Ensure this field has no more than 256 characters.'),
    access_secret: Yup.string()
      .required('Secret Key is required')
      .max(256, 'Ensure this field has no more than 256 characters.'),
    trading_account_id: Yup.string()
      .required('Trading Account ID is required')
      .max(256, 'Ensure this field has no more than 256 characters.'),
    entity: Yup.object().required('Entity is required'),
  });

  const handleSubmit = async (key, { setSubmitting }) => {
    try {
      await addApiKey(key);
      toggle();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {React.cloneElement(children, {
        onClick: toggle,
      })}
      {open && (
        <ParadigmModal title="Add Bullish Credentials" onClose={toggle}>
          <Formik
            initialValues={{
              name: '',
              access_key: '',
              access_secret: '',
              trading_account_id: '',
              entity: '',
              venue: source.shortName,
            }}
            onSubmit={handleSubmit}
            validationSchema={addKeySchema}
          >
            {(props) => (
              <AddKeyForm {...props} source={source} onClose={toggle} />
            )}
          </Formik>
        </ParadigmModal>
      )}
    </>
  );
};

export default React.memo(AddKey);
